import React from "react";
import { FormattedMessage } from "react-intl"; // Assuming you're using react-intl for i18n
import PropTypes from "prop-types";
import styles from "./RoomEntryModal.scss";

const CountdownDisplay = ({ timeLeft, isPresentation }) => {
  return (
    <div className={styles.timeLeft}>
      <p className={styles.timeLeftTitle}>
        {isPresentation ? (
          <FormattedMessage
            id="room-entry-modal.presentation-time-left"
            defaultMessage="The Presentation will start in:"
          />
        ) : (
          <FormattedMessage id="room-entry-modal.time-left" defaultMessage="The Activation will start in:" />
        )}
      </p>

      <div className={styles.humanTimeLeft}>
        {timeLeft.days !== "00" && (
          <div>
            <h3>{timeLeft.days}</h3>
            <p>
              <FormattedMessage
                id="room-entry-modal.days"
                defaultMessage="{days}"
                values={{ days: timeLeft.days === "01" ? "day" : "days" }}
              />
            </p>
          </div>
        )}

        <div>
          <h3>{timeLeft.hours}</h3>
          <p>
            <FormattedMessage
              id="room-entry-modal.hours"
              defaultMessage="{hours}"
              values={{ hours: timeLeft.hours === "01" ? "hour" : "hours" }}
            />
          </p>
        </div>

        <div>
          <h3>{timeLeft.minutes}</h3>
          <p>
            <FormattedMessage
              id="room-entry-modal.minutes"
              defaultMessage="{minutes}"
              values={{ minutes: timeLeft.minutes === "01" ? "minute" : "minutes" }}
            />
          </p>
        </div>

        {timeLeft.days === "00" && ( // Updated condition to correctly check for non-zero seconds
          <div>
            <h3>{timeLeft.seconds}</h3>
            <p>
              <FormattedMessage
                id="room-entry-modal.seconds"
                defaultMessage="{seconds}"
                values={{ seconds: timeLeft.seconds === "01" ? "second" : "seconds" }}
              />
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

CountdownDisplay.propTypes = {
  timeLeft: PropTypes.shape({
    days: PropTypes.string,
    hours: PropTypes.string,
    minutes: PropTypes.string,
    seconds: PropTypes.string
  }),
  isPresentation: PropTypes.bool
};

export default CountdownDisplay;
